import TagManager from 'react-gtm-module-v2';

const gtmId: string | undefined = process.env.REACT_APP_GTM_ID;

// GTMを初期化する関数
export const initGTM = (): void => {
  if (!gtmId) {
    return;
  }
  TagManager.initialize({ gtmId });
};
